import type { VoidFunctionComponent } from 'react';

import DetailsPanel from '../../../generic/DetailsPanel';
import RemediationPanels from '../RemediationPanels';
import { getRemediationCardFlags } from '../RemediationPanels/getRemediationCardFlags';
import type { UpgradeDistance } from '../../../../../shared/vulns/types';

import DrawerSection from './Section';

type Props = {
  version: string;
  isLoading?: boolean;
  completeFix: string;
  completeFixDistance?: UpgradeDistance;
  partialFix: string;
  partialFixDistance?: UpgradeDistance;
  isUserDefinedDependency?: boolean;
  isDetectedViaCpe?: boolean;
  onUpdateDependency?: () => void;
};

/**
 * VulnerabilityDrawerRemediation shows information related to
 * the "fixability" of the currently selected vulnerability.
 */
const VulnerabilityDrawerRemediation: VoidFunctionComponent<Props> = ({
  version,
  isLoading,
  completeFix,
  completeFixDistance,
  partialFix,
  partialFixDistance,
  isUserDefinedDependency,
  isDetectedViaCpe,
  onUpdateDependency,
}) => {
  const {
    shouldShowCompleteFix,
    shouldShowPartialFix,
    shouldShowNoFix,
    shouldShowUnableToCalculate,
  } = getRemediationCardFlags({ completeFix, partialFix, isUserDefinedDependency });

  return (
    <DrawerSection>
      <DetailsPanel id="package-inventory-vuln-drawer-remediation" target="Remediation" isLoading={isLoading}>
        <RemediationPanels
          version={version}
          isLoading={isLoading}
          shouldShowPartialFix={shouldShowPartialFix}
          shouldShowCompleteFix={shouldShowCompleteFix}
          shouldShowNoFix={shouldShowNoFix}
          completeFix={completeFix}
          completeFixDistance={completeFixDistance}
          partialFix={partialFix}
          partialFixDistance={partialFixDistance}
          shouldShowUnableToCalculate={shouldShowUnableToCalculate}
          isDetectedViaCpe={isDetectedViaCpe}
          onUpdateDependency={onUpdateDependency}
        />
      </DetailsPanel>
    </DrawerSection>
  );
};

export default VulnerabilityDrawerRemediation;
